"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVER_SIDE_AUTHORITATIVE_STATES = void 0;
var models_1 = require("../../models");
/**
 * All the states that are server side authoritative
 */
exports.SERVER_SIDE_AUTHORITATIVE_STATES = [
    models_1.CreatureStateType.Death,
];
